export default __webpack_public_path__ + "static/media/ddexsvg.a94b81ca.svg";